// Campos de PUT /bots/{id} que el formulario privado (BotEditPage) NO edita y
// que por tanto deben viajar como ECO del bot cargado -- mismo patrón que
// utils/marginMode.js (WP-wizard-exchange-modos) y que el eco de
// components/PublicBots/buildBotUpdatePayload.js.
//
// Por qué: PUT /bots/{id} REEMPLAZA todos los campos de BotUpdate
// (bot_service.update_bot); lo que el cliente no envía llega con el default
// del schema y pisa el valor guardado en silencio. Un único mapeo
// bot -> form.echo -> payload para que ningún campo se pierda por olvido
// (WP alineación formulario privado, docs/specs/Spec_Alineacion_Formulario_Privado.md;
// origen: deuda de 479ccc7, BotEditPage reseteaba sl_tp_source a bot_fixed).
//
// Al añadir un campo a BotUpdate que este formulario no edite, se añade AQUÍ
// (y el test de BotEditPage.echo.test.jsx lo cubre renderizando la página).

const TP_WEIGHTS_DEFAULT = [40, 30, 30]

// Defaults = los del schema BotCreate (comportamiento de un bot nuevo).
export const ECHO_DEFAULTS = {
  sl_tp_source: 'bot_fixed',
  sltp_backup_opt_out: false,
  tp_weights: TP_WEIGHTS_DEFAULT,
  indicator_engine_config: {},
  management_source: 'indicator',
  conflict_policy: 'ignore',
  conflict_config: {},
  circuit_breaker_enabled: false,
  notify_on_open: false,
  notify_on_partial: false,
  notify_on_close: false,
  // Valor que se envía en trigger_indicator cuando el form no tiene ninguno:
  // 'ict' para un bot nuevo (comportamiento histórico); null para un bot
  // guardado sin indicador (no se le inventa uno al editarlo).
  empty_trigger_indicator: 'ict',
}

export function echoFromBot(bot) {
  const b = bot ?? {}
  return {
    sl_tp_source: b.sl_tp_source ?? ECHO_DEFAULTS.sl_tp_source,
    sltp_backup_opt_out: b.sltp_backup_opt_out === true,
    tp_weights: Array.isArray(b.tp_weights) && b.tp_weights.length === 3
      ? b.tp_weights.map(Number)
      : TP_WEIGHTS_DEFAULT,
    indicator_engine_config: { ...(b.indicator_engine_config ?? {}) },
    management_source: b.management_source ?? ECHO_DEFAULTS.management_source,
    conflict_policy: b.conflict_policy ?? ECHO_DEFAULTS.conflict_policy,
    conflict_config: { ...(b.conflict_config ?? {}) },
    circuit_breaker_enabled: b.circuit_breaker_enabled === true,
    notify_on_open: b.notify_on_open === true,
    notify_on_partial: b.notify_on_partial === true,
    notify_on_close: b.notify_on_close === true,
    empty_trigger_indicator: b.trigger_indicator ? 'ict' : null,
  }
}

// Todo el eco menos conflict_config (el form lo edita por partes y lo mezcla
// encima del eco -- ver buildPayload) y empty_trigger_indicator (auxiliar).
export function echoToPayload(echo) {
  const e = { ...ECHO_DEFAULTS, ...(echo ?? {}) }
  return {
    sl_tp_source: e.sl_tp_source,
    sltp_backup_opt_out: e.sltp_backup_opt_out,
    tp_weights: e.tp_weights,
    indicator_engine_config: e.indicator_engine_config,
    management_source: e.management_source,
    conflict_policy: e.conflict_policy,
    circuit_breaker_enabled: e.circuit_breaker_enabled,
    notify_on_open: e.notify_on_open,
    notify_on_partial: e.notify_on_partial,
    notify_on_close: e.notify_on_close,
  }
}
